import React, { useCallback } from "react";
import styled from "styled-components";
import { Checkbox } from "@cld/checkbox";
import { InlineFieldLayout, Label } from "@cld/form";
import t from "common/i18n";
import { useFilterParams } from "../../selectors";
import { LastSectionBox } from "./Filters.styles";

const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	label {
		padding-top: 1px;
	}
`;

export default ({ handleSearch }) => {
	const { excludeNudity } = useFilterParams();
	const filterChange = useCallback((item) => {
		handleSearch({
			filters: {
				excludeNudity: !excludeNudity
			}
		});
	}, [handleSearch, excludeNudity]);
	
	return (<LastSectionBox data-test="more-section">
		<label>{t("istock.filters.more.label")}</label>
		<CheckboxContainer>
			<InlineFieldLayout label={<Label htmlFor="safe">{t("istock.filters.more.safe")}</Label>}>
				<Checkbox
					id="safe"
					value={excludeNudity}
					onClick={filterChange}
				/>
			</InlineFieldLayout>
		</CheckboxContainer>
	</LastSectionBox>);
};
